<div *ngIf="attachments && attachments.length" class="media-container">
  <div *ngFor="let attachment of attachments; let i = index"
       class="attachment-container">
    <div class="attachment-border">
      <div class="attachment">
        <img *ngIf="attachment.type === 'image'" [src]="attachment.thumb" alt=""
             [gallery]="'attachments-gallery'"
             [lightbox]="i">
        <video *ngIf="attachment.type === 'video'" [src]="attachment.src"
               [gallery]="'attachments-gallery'"
               [lightbox]="i"></video>
        <div *ngIf="attachment.type === 'document'" class="attachment-document" (click)="downloadAttachment(attachment.id)">
          <div class="attachment-document-icon">
            <mat-icon *ngIf="!isDownloading">file_present</mat-icon>
            <mat-icon *ngIf="isDownloading" class="loading">autorenew</mat-icon>
          </div>
        </div>
      </div>
    </div>
    <div class="attachment-details">
      <div class="attachment-filename" [matTooltip]="attachment.original_filename">{{ attachment.original_filename }}</div>
      <div class="attachment-size">{{ attachment.size }}</div>
    </div>
  </div>
</div>
